import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { UpgradeModalProvider } from "./context/UpgradeModalContext";
import UpgradeModal from "./components/UpgradeModal";
import PastDueBanner from "./components/PastDueBanner";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import Signup from "./pages/Signup";
import SignupSuccess from "./pages/SignupSuccess";
import SignupCancelled from "./pages/SignupCancelled";
import Billing from "./pages/Billing";
import Dashboard from "./pages/Dashboard";
import Parts from "./pages/Parts";
import Transactions from "./pages/Transactions";
import Categories from "./pages/Categories";
import Users from "./pages/Users";
import Reports from "./pages/Reports";
import Help from "./pages/Help";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import OfflineBanner from "./components/OfflineBanner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <UpgradeModalProvider>
          <BrowserRouter>
          <PastDueBanner />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/signup/success" element={<SignupSuccess />} />
            <Route path="/signup/cancelled" element={<SignupCancelled />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/help" element={<Help />} />
            <Route
              path="/billing"
              element={
                <ProtectedRoute>
                  <Billing />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Layout><Dashboard /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/parts"
              element={
                <ProtectedRoute>
                  <Layout><Parts /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/transactions"
              element={
                <ProtectedRoute>
                  <Layout><Transactions /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute roles={["admin", "warehouse_staff"]}>
                  <Layout><Reports /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/categories"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <Layout><Categories /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <Layout><Users /></Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <UpgradeModal />
        <PWAInstallPrompt />
        <OfflineBanner />
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              borderRadius: 0,
              border: "1px solid #d4d4d8",
              fontFamily: "'IBM Plex Sans', sans-serif",
            },
          }}
        />
        </UpgradeModalProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
